import React, {useEffect} from "react";
import {GameListSection} from "../../contenful/types";
import './styles/GameListSectionComponent.scss';
import {Link} from "react-router-dom";
import ListOfGamePromo from './ListOfGamePromo';
import {t} from "../../i18n";
// import {isMobile} from "react-device-detect";
import {prettyUrl} from "../../utils/UrlUtils";
import {loadCasinoGames} from "../../casino/CasinoActions";
import {useDispatch, useSelector} from "react-redux";
import {CategoryGames} from "../../selectors/casino-selectors";
import { AppState } from "../../RootReducer";


interface Props {
    section: GameListSection;
    mobile?: boolean;
    id?: any;
    hoverPlayButton?: boolean;
}

const GameListSectionComponent = (props: Props) => {
    const isMobile = useSelector((app: AppState)=> app.settings.mobile)

    const renderSeeAll = () => {
        const linkToCategoryId = `/casino/${props.section.categoryId && props.section.categoryId}/${prettyUrl(`${props.section.categoryName ? props.section.categoryName : ''}`)}`
        const linkToCategoryLink = props.section.categoryLink && props.section.categoryLink
        let linkToUse;
        if(linkToCategoryLink && linkToCategoryId) linkToUse = linkToCategoryLink
        if(!linkToCategoryLink && linkToCategoryId) linkToUse = linkToCategoryId
        if(linkToCategoryLink && !linkToCategoryId) linkToUse = linkToCategoryLink

        if(!props.section.categoryLink && !props.section.categoryId) {
            return <></>
        } else if(props.section.categoryId) {
            return (
                <Link to={`${linkToCategoryId}`} className="see-all">
                    {t("gameListSection.seeAll")} <i className={"material-icons"}>chevron_right</i>
                </Link>
            )
        } else {
            return (
                <Link to={`${linkToUse}`} className="see-all">
                    {t("gameListSection.seeAll")} <i className={"material-icons"}>chevron_right</i>
                </Link>
            )
        }

    }

    const mobile = isMobile ? 'mobile' : 'desktop'
    const backgroundColor = props.section && props.section.backgroundColor ? props.section.backgroundColor : ''
    let promos = props.section.listOfGamePromo;
    const titleIcon = props.section.titleIcon && props.section.titleIcon
    return (
            <div className={`gameListSection ${props.section.cssClassName ?? ""}`} style={{backgroundColor: backgroundColor}}>
                <div className={`container`}>
                    <div className="section-outer">
                        <div className="title-wrapper">
                            <div className={"title-text"}>
                                <h4 className="title">
                                    {titleIcon && titleIcon?.fields && titleIcon?.fields?.file && <img src={`${titleIcon.fields.file.url}`} className="icon"/>}
                                    {props.section.title}
                                </h4>
                                {props.section.description && <h6>{props.section.description}</h6>}
                            </div>
                            {renderSeeAll()}
                        </div>
                        <div className={`inner-section ${mobile}`}>
                            <ListOfGamePromo list={promos} listId={props.section._id} hoverPlayButton={props.hoverPlayButton} />
                        </div>
                    </div>
                </div>
            </div>
    )

}
interface CatProps extends Props {
    categoryGames? : CategoryGames[]
}

export const CategoryGameListSectionComponent = (props: CatProps) => {

    const isMobile = useSelector((app: AppState)=> app.settings.mobile)


    const renderSeeAll = () => {
        const linkToCategoryId = `/casino/category/${props.section.categoryId && props.section.categoryId}/${prettyUrl(`${props.section.categoryName ? props.section.categoryName : 'category'}`)}`
       return (
           <Link to={linkToCategoryId} className="see-all">
               {t("gameListSection.seeAll")} <i className={"material-icons"}>chevron_right</i>
           </Link>
       )

    }
    const mobile = isMobile ? 'mobile' : 'desktop'
    const backgroundColor = props.section && props.section.backgroundColor ? props.section.backgroundColor : ''
    let promos = props.section.listOfGamePromo;
    return (
        <div className={`gameListSection  ${props.section.cssClassName ?? ""}`} style={{backgroundColor: backgroundColor}}>
            <div className={`container`}>
                <div className="section-outer">
                    <div className="title-wrapper">
                        <div className={"title-text"}>
                            <h4 className="title">{props.section.title}</h4>
                            {props.section.description && <h6>{props.section.description}</h6>}
                        </div>
                        {renderSeeAll()}
                    </div>
                    <div className={`inner-section ${mobile}`}>
                        <ListOfGamePromo list={promos}  listId={props.section._id}/>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default GameListSectionComponent
